import styled from "styled-components";

export const Container = styled.div `
    width: 100%;
    max-width: 1200px;
    margin: auto;
`

export const Header = styled.header `
    display: flex;
    align-items: center;

    button {
        height: 40px;
        width: 40px;
        border-radius: 50px;
        background: #404040;
        font-size: 1.1rem;
        cursor: pointer;
        color: #fff;
        border: none;
        margin-right: 10px;
        transition: all .3s ease;
    }

    button:hover {
        background: #505050;
    }

    h3 {
        font-size: 1.5rem;
    }
`

export const Main = styled.main `
    margin-top: 50px;

    .loading {
        display: flex;
        justify-content: center;
    }
`

export const Profiles = styled.div `
`

export const Section = styled.main `

    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 3px solid #505050;

    &:last-child {
        border: none;
    }
    
    h2 {
        margin-bottom: 10px;
        position: relative;
    }

    h4 {
        font-size: 1.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    h4 img {
        width: 20px;
        margin: 0 0 -2px 0;
    }

    p, .account-created {
        font-size: .8rem;
        font-weight: 500;
    }

    .member-since-until {
        display: flex;
        justify-content: space-between;
        max-width: 500px;
        margin-top: 10px;
    }

    @media (max-width: 400px) {
        h2 {
            font-size: 1.2rem;
        }

        h4 {
            font-size: 1rem;
            margin-bottom: 5px;
        }

        .email, .account-created {
            font-size: .7rem;
        }
    }

`
